"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubDashboard = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var Dialog_1 = require("office-ui-fabric-react/lib/Dialog");
require("./styles/dashboard.scss");
var dashboard_utils_1 = require("./utils/dashboard-utils");
var config_1 = require("../config");
var ViewSwitcher_1 = require("../ViewSwitcher/ViewSwitcher");
var DashboardFlow_1 = require("../DashboardFlow/DashboardFlow");
var ProgressView_1 = require("../ProgressView/ProgressView");
var ListView_1 = require("../ListView/ListView");
var PriorityReadinessChart_1 = require("../PriorityReadinessChart/PriorityReadinessChart");
var ai_hub_rbac_api_service_1 = require("../shared/services/ai-hub-rbac-api.service");
var hooks_1 = require("../shared/hooks");
var prioritisation_1 = require("../shared/utils/prioritisation");
var ai_hub_readiness_api_service_1 = __importDefault(require("../shared/services/ai-hub-readiness-api.service"));
var addIcon = { iconName: "CircleAddition" };
var AREA_OPTIONS = [
    { key: "operations", text: "Operations" },
    { key: "delivery", text: "Delivery" },
    { key: "client", text: "Client" },
];
var CLIENT_GROUP_OPTIONS = [
    { key: "avanade", text: "Avanade" },
    { key: "resources", text: "Resources" },
    { key: "comms-media-and-technology", text: "Comms, Media & Technology" },
    { key: "financial-services", text: "Financial Services" },
    { key: "health-and-public-services", text: "Health & Public Services" },
    { key: "other", text: "Other" },
];
var BUSINESS_FUNCTION_OPTIONS = [
    { key: "delivery", text: "Delivery" },
    { key: "finance", text: "Finance" },
    { key: "hr", text: "HR" },
    { key: "it", text: "IT" },
    { key: "migrations", text: "Migrations" },
    { key: "sales", text: "Sales" },
];
var STAGE_OPTIONS = [
    { key: "submitted", text: "Submitted (AI Hub)" },
    { key: "qualified", text: "Qualified (AI Hub)" },
    { key: "prioritised", text: "Prioritised (AI Hub)" },
    { key: "approved", text: "Approved (AI Hub)" },
];
var DEFAULT_STAGE = "submitted";
var DEFAULT_SOURCE = "Linklaters (DevOps)";
var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var READINESS_WORKFLOW_ID = "ukdc";
var clampPercent = function (value) {
    if (!Number.isFinite(value)) {
        return 0;
    }
    if (value < 0) {
        return 0;
    }
    if (value > 100) {
        return 100;
    }
    return value;
};
var toReadinessPercentage = function (rawScore) {
    if (typeof rawScore !== "number" || !Number.isFinite(rawScore)) {
        return null;
    }
    return rawScore >= 0 && rawScore <= 1 ? rawScore * 100 : rawScore;
};
var getReadinessScoreFromUseCase = function (useCase) {
    var normalizedTopLevelScore = toReadinessPercentage(useCase.readinessScore);
    if (typeof normalizedTopLevelScore === "number") {
        return clampPercent(normalizedTopLevelScore);
    }
    // Readiness must come from backend readiness calculation (ready element coverage),
    // never from free-text fields.
    return 0;
};
var toImpactPercentage = function (rawScore) {
    if (typeof rawScore !== "number" || !Number.isFinite(rawScore)) {
        return 0;
    }
    return clampPercent(rawScore >= 0 && rawScore <= 1 ? rawScore * 100 : rawScore);
};
var initialCreateUseCaseDraftForm = function () { return ({
    title: "",
    ideaDescription: "",
    owner: "",
    ownerEmail: "",
    area: "",
    clientGroup: "",
    businessFunction: "",
    stage: DEFAULT_STAGE,
}); };
var getPreferredUserName = function (user) {
    var _a, _b;
    var displayName = (_a = user.displayName) === null || _a === void 0 ? void 0 : _a.trim();
    if (displayName) {
        return displayName;
    }
    return ((_b = user.email) === null || _b === void 0 ? void 0 : _b.trim()) || user.objectId;
};
/**
 * WsAiHubDashboard - Dashboard tab for browsing AI use cases in multiple views.
 *
 * @param {WsAiHubDashboardProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubDashboard = function (props) {
    var onImportRunCreated = props.onImportRunCreated, onRefresh = props.onRefresh, _a = props.isImportRunActive, isImportRunActive = _a === void 0 ? false : _a, useCases = props.useCases;
    var _b = hooks_1.useStrategies(), strategies = _b.data, isLoadingStrategies = _b.isLoading;
    var _c = react_1.useState("list"), selectedView = _c[0], setSelectedView = _c[1];
    var _d = react_1.useState(""), selectedStrategyId = _d[0], setSelectedStrategyId = _d[1];
    var _e = react_1.useState({}), readinessScoresByUseCaseId = _e[0], setReadinessScoresByUseCaseId = _e[1];
    var _f = react_1.useState(false), isImporting = _f[0], setIsImporting = _f[1];
    var _g = react_1.useState(false), isCreatingUseCase = _g[0], setIsCreatingUseCase = _g[1];
    var _h = react_1.useState(false), isCreateUseCaseModalOpen = _h[0], setIsCreateUseCaseModalOpen = _h[1];
    var _j = react_1.useState(initialCreateUseCaseDraftForm), createUseCaseForm = _j[0], setCreateUseCaseForm = _j[1];
    var _k = react_1.useState([]), directoryOwners = _k[0], setDirectoryOwners = _k[1];
    var _l = react_1.useState(null), message = _l[0], setMessage = _l[1];
    react_1.useEffect(function () {
        var cancelled = false;
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, allUsers, currentUser, activeUsers, mergedUsers, ownersByKey, sortedOwners;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ai_hub_rbac_api_service_1.fetchUsers(), ai_hub_rbac_api_service_1.fetchCurrentUser()])];
                    case 1:
                        _a = _b.sent(), allUsers = _a[0], currentUser = _a[1];
                        activeUsers = allUsers.filter(function (user) { return user.isActive !== false; });
                        mergedUsers = currentUser
                            ? __spreadArrays(activeUsers, [currentUser]) : activeUsers;
                        ownersByKey = new Map();
                        mergedUsers.forEach(function (user) {
                            var _a;
                            var name = getPreferredUserName(user).trim();
                            if (!name) {
                                return;
                            }
                            var email = ((_a = user.email) === null || _a === void 0 ? void 0 : _a.trim()) || undefined;
                            var key = user.objectId || email || name.toLowerCase();
                            ownersByKey.set(key, { key: key, name: name, email: email });
                        });
                        sortedOwners = Array.from(ownersByKey.values()).sort(function (leftValue, rightValue) {
                            return leftValue.name.localeCompare(rightValue.name, undefined, {
                                sensitivity: "base",
                            });
                        });
                        if (!cancelled) {
                            setDirectoryOwners(sortedOwners);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        void run();
        return function () {
            cancelled = true;
        };
    }, []);
    react_1.useEffect(function () {
        if (selectedStrategyId) {
            var strategyStillExists = strategies.some(function (strategy) { return String(strategy.id) === selectedStrategyId; });
            if (strategyStillExists) {
                return;
            }
        }
        setSelectedStrategyId(strategies.length > 0 ? String(strategies[0].id) : "");
    }, [selectedStrategyId, strategies]);
    react_1.useEffect(function () {
        var cancelled = false;
        if (selectedView !== "prioritisation" || useCases.length === 0) {
            setReadinessScoresByUseCaseId({});
            return function () {
                cancelled = true;
            };
        }
        var loadReadinessScores = function () { return __awaiter(void 0, void 0, void 0, function () {
            var entries, nextScores;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(useCases.map(function (useCase) { return __awaiter(void 0, void 0, void 0, function () {
                            var useCaseId, score, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        useCaseId = String(useCase.id || "").trim();
                                        if (!useCaseId) {
                                            return [2 /*return*/, ["", 0]];
                                        }
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, ai_hub_readiness_api_service_1.default.getUseCaseReadinessScore(READINESS_WORKFLOW_ID, useCaseId)];
                                    case 2:
                                        score = _b.sent();
                                        return [2 /*return*/, [useCaseId, clampPercent(score)]];
                                    case 3:
                                        _a = _b.sent();
                                        return [2 /*return*/, [useCaseId, getReadinessScoreFromUseCase(useCase)]];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }))];
                    case 1:
                        entries = _a.sent();
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        nextScores = entries.reduce(function (result, _a) {
                            var useCaseId = _a[0], score = _a[1];
                            if (!useCaseId) {
                                return result;
                            }
                            result[useCaseId] = score;
                            return result;
                        }, {});
                        setReadinessScoresByUseCaseId(nextScores);
                        return [2 /*return*/];
                }
            });
        }); };
        void loadReadinessScores();
        return function () {
            cancelled = true;
        };
    }, [selectedView, useCases]);
    var stageCounts = dashboard_utils_1.getStageCounts(useCases);
    var readinessChartUseCases = react_1.useMemo(function () {
        return useCases.map(function (useCase) { return ({
            id: useCase.id,
            title: useCase.title,
            readinessScore: typeof readinessScoresByUseCaseId[useCase.id] === "number"
                ? readinessScoresByUseCaseId[useCase.id]
                : getReadinessScoreFromUseCase(useCase),
            impactScore: toImpactPercentage(selectedStrategyId
                ? prioritisation_1.getPrioritisationScoreForStrategy(useCase.fields.Prioritisation, selectedStrategyId)
                : null),
        }); });
    }, [readinessScoresByUseCaseId, selectedStrategyId, useCases]);
    var strategyOptions = react_1.useMemo(function () { return strategies.map(function (strategy) { return ({ key: String(strategy.id), text: strategy.name }); }); }, [strategies]);
    var impactAxisLabel = "IMPACT";
    var ownerSuggestions = react_1.useMemo(function () {
        var ownersByKey = new Map();
        directoryOwners.forEach(function (owner) {
            ownersByKey.set(owner.key, owner);
        });
        var uniqueOwners = {};
        useCases.forEach(function (useCase) {
            var _a;
            var candidates = [
                (_a = useCase.fields) === null || _a === void 0 ? void 0 : _a.Owner,
                useCase.ownerName,
            ];
            candidates.forEach(function (candidate) {
                if (typeof candidate !== "string") {
                    return;
                }
                var trimmedCandidate = candidate.trim();
                if (!trimmedCandidate) {
                    return;
                }
                uniqueOwners[trimmedCandidate] = true;
            });
        });
        var resolvedOwners = Object.keys(uniqueOwners).sort(function (leftValue, rightValue) {
            return leftValue.localeCompare(rightValue, undefined, {
                sensitivity: "base",
            });
        });
        resolvedOwners.forEach(function (ownerName) {
            var key = "history:" + ownerName.toLowerCase();
            if (!ownersByKey.has(key)) {
                ownersByKey.set(key, { key: key, name: ownerName });
            }
        });
        return Array.from(ownersByKey.values()).sort(function (leftValue, rightValue) {
            return leftValue.name.localeCompare(rightValue.name, undefined, {
                sensitivity: "base",
            });
        });
    }, [directoryOwners, useCases]);
    var ownerOptions = react_1.useMemo(function () {
        return ownerSuggestions.map(function (owner) { return ({
            key: owner.key,
            text: owner.name,
            data: {
                email: owner.email,
            },
        }); });
    }, [ownerSuggestions]);
    var resetCreateUseCaseForm = react_1.useCallback(function () {
        setCreateUseCaseForm(initialCreateUseCaseDraftForm());
    }, []);
    var closeCreateUseCaseModal = react_1.useCallback(function () {
        setIsCreateUseCaseModalOpen(false);
        resetCreateUseCaseForm();
    }, [resetCreateUseCaseForm]);
    var openCreateUseCaseModal = react_1.useCallback(function () {
        setIsCreateUseCaseModalOpen(true);
        setMessage(null);
    }, []);
    var resolveOptionText = react_1.useCallback(function (options, key) {
        var match = options.find(function (option) { return String(option.key) === key; });
        return (match === null || match === void 0 ? void 0 : match.text) || key;
    }, []);
    var handleCreateUseCaseDraft = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, createResult, jobIdText, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!createUseCaseForm.title.trim()
                        || !createUseCaseForm.ideaDescription.trim()
                        || !createUseCaseForm.owner.trim()
                        || !createUseCaseForm.area
                        || !createUseCaseForm.clientGroup
                        || !createUseCaseForm.businessFunction) {
                        setMessage({
                            text: "Please complete all required fields before creating a use case draft.",
                            type: office_ui_fabric_react_1.MessageBarType.warning,
                        });
                        return [2 /*return*/];
                    }
                    setIsCreatingUseCase(true);
                    setMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, config_1.getApiPost()("/ai/ukdc/use-cases/create-and-qualify-from-ado", {
                            title: createUseCaseForm.title.trim(),
                            ideaDescription: createUseCaseForm.ideaDescription.trim(),
                            ownerName: createUseCaseForm.owner.trim(),
                            ownerEmail: createUseCaseForm.ownerEmail.trim() || undefined,
                            area: resolveOptionText(AREA_OPTIONS, createUseCaseForm.area),
                            clientGroup: resolveOptionText(CLIENT_GROUP_OPTIONS, createUseCaseForm.clientGroup),
                            businessFunction: resolveOptionText(BUSINESS_FUNCTION_OPTIONS, createUseCaseForm.businessFunction),
                            sourceSystem: DEFAULT_SOURCE,
                            stage: createUseCaseForm.stage,
                        })];
                case 2:
                    response = _a.sent();
                    createResult = response;
                    jobIdText = createResult.jobId ? " Job ID: " + createResult.jobId + "." : "";
                    setMessage({
                        text: "Use case created and qualification started in background." + jobIdText,
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    closeCreateUseCaseModal();
                    onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setMessage({
                        text: error_1 instanceof Error ? error_1.message : "Failed to create and qualify use case.",
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setIsCreatingUseCase(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        closeCreateUseCaseModal,
        createUseCaseForm,
        onRefresh,
        resolveOptionText,
    ]);
    var handleImport = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isImportRunActive) {
                        return [2 /*return*/];
                    }
                    setIsImporting(true);
                    setMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, config_1.getApiPost()("/ai/ukdc/import/runs", {})];
                case 2:
                    _a.sent();
                    setMessage({
                        text: "Import run started successfully.",
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    return [4 /*yield*/, (onImportRunCreated === null || onImportRunCreated === void 0 ? void 0 : onImportRunCreated())];
                case 3:
                    _a.sent();
                    onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh();
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    setMessage({
                        text: error_2 instanceof Error ? error_2.message : "Failed to start import run.",
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setIsImporting(false);
                    setTimeout(function () { return setMessage(null); }, 5000);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [isImportRunActive, onImportRunCreated, onRefresh]);
    return (react_1.default.createElement("div", { className: "ws-ai-hub-dashboard " + (selectedView === "list" ? "ws-ai-hub-dashboard-list-mode" : "") },
        react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-actions" },
            react_1.default.createElement(ViewSwitcher_1.WsAiHubDashboardViewSwitcher, { selectedView: selectedView, onViewChange: setSelectedView }),
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-actions-buttons" },
                react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ws-admin-button-hover-accent ws-admin-button-add ws-ai-hub-dashboard-action-button", iconProps: addIcon, onClick: openCreateUseCaseModal }, "Create new use-case"),
                react_1.default.createElement("span", { className: "ws-ai-hub-dashboard-action-separator", "aria-hidden": "true" }),
                react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ws-admin-button-hover-accent ws-ai-hub-dashboard-action-button", iconProps: {
                        iconName: "Sync",
                        className: isImporting ? "ws-spin" : "",
                    }, disabled: isImporting || isImportRunActive, onClick: handleImport }, isImporting
                    ? "Starting Import..."
                    : isImportRunActive
                        ? "Import In Progress"
                        : "Import New Use Cases"))),
        message && (react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: message.type }, message.text)),
        react_1.default.createElement(Dialog_1.Dialog, { hidden: !isCreateUseCaseModalOpen, onDismiss: closeCreateUseCaseModal, dialogContentProps: {
                type: Dialog_1.DialogType.largeHeader,
                title: "Create a new use case",
            }, modalProps: {
                isBlocking: false,
                className: "ws-ai-hub-create-use-case-dialog",
            } },
            react_1.default.createElement("div", { className: "ws-ai-hub-create-use-case-modal", role: "form", "aria-label": "Create a new use case form" },
                react_1.default.createElement("div", { className: "ws-ai-hub-create-use-case-modal-grid" },
                    react_1.default.createElement(office_ui_fabric_react_1.TextField, { label: "Title", placeholder: "Enter use case title", value: createUseCaseForm.title, onChange: function (_event, newValue) {
                            setCreateUseCaseForm(function (previousValue) { return (__assign(__assign({}, previousValue), { title: newValue || "" })); });
                        }, required: true }),
                    react_1.default.createElement(office_ui_fabric_react_1.TextField, { label: "Idea description", placeholder: "Describe the problem, expected value, and target users", multiline: true, rows: 4, value: createUseCaseForm.ideaDescription, onChange: function (_event, newValue) {
                            setCreateUseCaseForm(function (previousValue) { return (__assign(__assign({}, previousValue), { ideaDescription: newValue || "" })); });
                        }, required: true }),
                    react_1.default.createElement(office_ui_fabric_react_1.ComboBox, { label: "Owner", placeholder: "Start typing owner name", allowFreeform: true, autoComplete: "on", options: ownerOptions, text: createUseCaseForm.owner, onChange: function (_event, option, _index, value) {
                            var typedValue = typeof value === "string" ? value.trim() : "";
                            var selectedName = typeof (option === null || option === void 0 ? void 0 : option.text) === "string" ? option.text.trim() : "";
                            var resolvedOwnerName = typedValue || selectedName;
                            var selectedEmail = typeof (option === null || option === void 0 ? void 0 : option.data) === "object" && (option === null || option === void 0 ? void 0 : option.data) !== null
                                ? String(option.data.email || "").trim()
                                : "";
                            var typedEmail = EMAIL_PATTERN.test(typedValue) ? typedValue : "";
                            setCreateUseCaseForm(function (previousValue) { return (__assign(__assign({}, previousValue), { owner: resolvedOwnerName, ownerEmail: selectedEmail || typedEmail })); });
                        }, required: true }),
                    react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Area", placeholder: "Select area", options: AREA_OPTIONS, selectedKey: createUseCaseForm.area || undefined, onChange: function (_event, option) {
                            setCreateUseCaseForm(function (previousValue) { return (__assign(__assign({}, previousValue), { area: String((option === null || option === void 0 ? void 0 : option.key) || "") })); });
                        }, required: true }),
                    react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Client group", placeholder: "Select client group", options: CLIENT_GROUP_OPTIONS, selectedKey: createUseCaseForm.clientGroup || undefined, onChange: function (_event, option) {
                            setCreateUseCaseForm(function (previousValue) { return (__assign(__assign({}, previousValue), { clientGroup: String((option === null || option === void 0 ? void 0 : option.key) || "") })); });
                        }, required: true }),
                    react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Business function", placeholder: "Select business function", options: BUSINESS_FUNCTION_OPTIONS, selectedKey: createUseCaseForm.businessFunction || undefined, onChange: function (_event, option) {
                            setCreateUseCaseForm(function (previousValue) { return (__assign(__assign({}, previousValue), { businessFunction: String((option === null || option === void 0 ? void 0 : option.key) || "") })); });
                        }, required: true }),
                    react_1.default.createElement(office_ui_fabric_react_1.TextField, { label: "Source", value: DEFAULT_SOURCE, readOnly: true }),
                    react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Stage", options: STAGE_OPTIONS, selectedKey: createUseCaseForm.stage, disabled: true })),
                react_1.default.createElement(Dialog_1.DialogFooter, null,
                    react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { onClick: closeCreateUseCaseModal, disabled: isCreatingUseCase }, "Cancel"),
                    react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { type: "button", disabled: isCreatingUseCase, onClick: function () {
                            void handleCreateUseCaseDraft();
                        } }, isCreatingUseCase ? "Creating..." : "Create use case")))),
        selectedView === "dashboard" && (react_1.default.createElement(DashboardFlow_1.WsAiHubDashboardFlow, { useCases: useCases, stageCounts: stageCounts })),
        selectedView === "progress" && (react_1.default.createElement(ProgressView_1.WsAiHubDashboardProgressView, { useCases: useCases, stageCounts: stageCounts })),
        selectedView === "list" && (react_1.default.createElement(ListView_1.WsAiHubDashboardListView, { useCases: useCases })),
        selectedView === "prioritisation" && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-prioritisation-controls" },
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Strategy", placeholder: isLoadingStrategies ? "Loading strategies..." : "Select strategy", options: strategyOptions, selectedKey: selectedStrategyId || undefined, onChange: function (_event, option) {
                        setSelectedStrategyId(String((option === null || option === void 0 ? void 0 : option.key) || ""));
                    }, disabled: isLoadingStrategies || strategyOptions.length === 0 })),
            react_1.default.createElement(PriorityReadinessChart_1.WsPriorityReadinessChart, { useCases: readinessChartUseCases, impactAxisLabel: impactAxisLabel })))));
};
exports.WsAiHubDashboard = WsAiHubDashboard;
